module.exports = __webpack_public_path__ + "static/media/icons-20.0a5c7651.eot";